import { useMutation, useQueryClient } from '@tanstack/react-query'
import { unsubmitPlan } from '@/api/submissions'
import { queryKeys } from '@/lib/queryKeys'
import { toast } from '@/stores/useToastStore'

/**
 * Hook for withdrawing (unsubmitting) a pending plan submission.
 */
export function useUnsubmitPlan(planId: string) {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (submissionId: string) => unsubmitPlan(planId, submissionId),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: queryKeys.planDetail.byId(planId),
      })
      queryClient.invalidateQueries({
        queryKey: queryKeys.planDetail.metadata(planId),
      })
      queryClient.invalidateQueries({
        queryKey: queryKeys.assortmentPlans.all,
      })
      queryClient.invalidateQueries({
        queryKey: queryKeys.submissions.byPlanId(planId),
      })
      toast.success('Submission withdrawn successfully')
    },
    onError: (error: Error) => {
      toast.error(error.message || 'Failed to withdraw submission')
    },
  })
}
